import { useState, useEffect } from "react";
import { Card, Input, Label, Title, TextArea, Overlay, ModalCloseButton } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";
import { addAuthor } from "../../services/AuthorService";
import DatePicker from "../CommonComponents/DatePicker";

const EMPTY_FORM = {
    name: "",
    surname: "",
    dateOfBirth: "",
    dateOfDeath: "",
    placeOfBirth: "",
    placeOfDeath: "",
    biography: "",
};

function isValidUrl(value) {
    try {
        const url = new URL(value);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch {
        return false;
    }
}

function AddAuthorModal({ isOpen, onClose, onAuthorAdded }) {
    const [form, setForm] = useState(EMPTY_FORM);
    const [biographyType, setBiographyType] = useState("text"); // "text" | "url"
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (isOpen) {
            setForm(EMPTY_FORM);
            setBiographyType("text");
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleBiographyTypeChange = (type) => {
        setBiographyType(type);
        setForm((prev) => ({ ...prev, biography: "" }));
    };

    const handleSubmit = async () => {
        setError("");
        if (biographyType === "url" && form.biography && !isValidUrl(form.biography)) {
            setError("Unesena biografija nije ispravna URL adresa (mora počinjati s http:// ili https://).");
            return;
        }
        setLoading(true);
        try {
            const newAuthor = await addAuthor(form);
            onAuthorAdded(newAuthor);
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Overlay onClick={onClose} style={{ alignItems: "flex-start", padding: "2rem 1rem", overflowY: "auto", boxSizing: "border-box" }}>
            <div onClick={(e) => e.stopPropagation()} style={{ width: "fit-content" }}>
            <Card style={{ position: "relative", width: "400px" }}>
                <ModalCloseButton onClick={onClose} title="Zatvori" style={{ position: "absolute", top: "0.75rem", right: "0.75rem" }}>×</ModalCloseButton>
                <Title>Dodaj novog autora</Title>

                <Label>Ime:</Label>
                <Input name="name" value={form.name} onChange={handleChange} />

                <Label>Prezime:</Label>
                <Input name="surname" value={form.surname} onChange={handleChange} />

                <Label>Datum rođenja:</Label>
                <DatePicker name="dateOfBirth" value={form.dateOfBirth} onChange={handleChange} />

                <Label>Datum smrti:</Label>
                <DatePicker name="dateOfDeath" value={form.dateOfDeath} onChange={handleChange} />

                <Label>Mjesto rođenja:</Label>
                <Input name="placeOfBirth" value={form.placeOfBirth} onChange={handleChange} />

                <Label>Mjesto smrti:</Label>
                <Input name="placeOfDeath" value={form.placeOfDeath} onChange={handleChange} />

                <Label>Vrsta unosa biografije:</Label>
                <div style={{ display: "flex", gap: "16px", marginBottom: "8px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                        <input
                            type="radio"
                            name="biographyType"
                            value="text"
                            checked={biographyType === "text"}
                            onChange={() => handleBiographyTypeChange("text")}
                        />
                        Vlastiti tekst
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
                        <input
                            type="radio"
                            name="biographyType"
                            value="url"
                            checked={biographyType === "url"}
                            onChange={() => handleBiographyTypeChange("url")}
                        />
                        Poveznica (URL)
                    </label>
                </div>

                {biographyType === "url" ? (
                    <>
                        <Label>URL biografije:</Label>
                        <Input
                            name="biography"
                            value={form.biography}
                            onChange={handleChange}
                            placeholder="https://..."
                        />
                    </>
                ) : (
                    <>
                        <Label>Biografija:</Label>
                        <TextArea
                            name="biography"
                            value={form.biography}
                            onChange={handleChange}
                            placeholder="Unesite biografiju autora..."
                            rows={6}
                        />
                    </>
                )}

                {error && <div style={{ color: "red", margin: "8px 0" }}>{error}</div>}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
                    <Button akcija={onClose} tekst="Odustani" />
                    <Button akcija={handleSubmit} tekst={loading ? "Spremanje..." : "Dodaj"} />
                </div>
            </Card>
            </div>
        </Overlay>
    );
}

export default AddAuthorModal;
